<!--
* 组件名 : 首页头部导航
* 开发者 : JY
*
* 参数:
*  navData     { Object }   required - 导航数据
*
* 事件:  null
*
*
-->
<template>
  <div class="home-nav">
    <div class="home-header d-flex align-items-center justify-content-between">
      <a :href="navData.logo.link" target="_blank" class="logo">
        <img :src="navData.logo.img" :alt="navData.logo.alt" />
      </a>
      <nav class="navbar d-flex">
        <a
          target="_blank"
          :href="item.link"
          class="nav-item"
          v-for="(item, i) in navData.data"
          :key="i"
        >
          {{ item.info }}
        </a>

        <font-zawgyi v-if="$P.my" />
      </nav>
    </div>
  </div>
</template>

<script>
import fontZawgyi from "@/components/font-zawgyi/index.vue";
export default {
  name: "home-nav",
  props: {
    navData: {
      type: Object,
      required: true,
    },
  },

  components: {
    fontZawgyi,
  },
};
</script>

<style lang="scss">
.home-nav {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 22;

  .home-header {
    height: 70px;
    width: 100%;
    padding: 6px 40px;

    .logo {
      height: 100%;
      img {
        height: 100%;
      }
    }

    .navbar {
      a {
        display: inline-block;
        margin-right: 44px;
        color: $color-white;
        text-decoration: none;

        &:hover {
          color: #fec648;
        }
      }
    }
  }
}

body.latin {
  .home-nav .home-header .logo,
  .home-nav .home-header .logo img {
    height: 100%;
  }
}

body[data-site="gospel"] {
  .home-nav {
    .home-header {
      padding: {
        top: 0px;
        bottom: 0px;
      }
    }
  }
}
</style>
